import { UseAxiosOptions, useAxios } from '@vueuse/integrations/useAxios';
import { AxiosRequestConfig } from 'axios';

type FetchOptions<T> = Omit<AxiosRequestConfig<T>, 'data'> & UseAxiosOptions<T> & { transformApiRequest?: boolean; data?: unknown };

function getTransformResponse<T>(config: FetchOptions<T>) {
   return config.transformResponse ?? (config.transformApiRequest ? (response: any) => JSON.parse(response).data : undefined);
}

export function useFetch<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(url, { ...config, transformResponse: getTransformResponse(config) }, http, { immediate: true, ...config });
}

export function usePost<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(url, { ...config, transformResponse: getTransformResponse(config), method: 'post' }, http, {
      immediate: true,
      ...config,
      abortPrevious: false,
   });
}

export function usePut<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(url, { ...config, transformResponse: getTransformResponse(config), method: 'put' }, http, {
      immediate: true,
      ...config,
      abortPrevious: false,
   });
}

export function usePatch<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(url, { ...config, transformResponse: getTransformResponse(config), method: 'patch' }, http, {
      immediate: true,
      ...config,
      abortPrevious: false,
   });
}

export function useDelete<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(url, { ...config, transformResponse: getTransformResponse(config), method: 'delete' }, http, {
      immediate: true,
      ...config,
      abortPrevious: false,
   });
}
